import customAxios from "./axiosConfig";
const PlantransactionService = {
    retrieve: function (pk) {
        var api_url = window.Urls['plantransaction-detail'](pk);
        console.log(api_url);
        return customAxios.get(api_url);
    },
    inititateAdyenPaymentSession: function (pk){
        var api_url = window.Urls['plantransaction_initiate_adyen_payment_session'](pk);
        return customAxios.post(api_url);
    },
    validate: function (data){
    var api_url = window.Urls['plantransaction_validate']();
    return customAxios.post(api_url, data);
    }
};
export default PlantransactionService;